"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toEventHash = void 0;
var toSignatureHash_js_1 = require("./toSignatureHash.js");
Object.defineProperty(exports, "toEventHash", { enumerable: true, get: function () { return toSignatureHash_js_1.toSignatureHash; } });
//# sourceMappingURL=toEventHash.js.map